import { style } from 'typestyle';
import { TEAL_PRIMARY } from 'src/utils/Style/Theme';
import { createStyles } from '@material-ui/core';
import { StyledTypographyProps } from 'src/components/ViewConfiguratorModal/ViewConfiguratorModal';

const viewConfiguratorStyles = style({
  width: '500px',
  height: '570px',
  position: 'relative',
  $nest: {
    '.columns-title-container': {
      height: 40,
      fontWeight: 'bold',
      display: 'grid',
      gridTemplateColumns: 'auto 55px 55px',
      padding: '0 1.3rem',
    },
    '.search-container': {
      padding: '0 1.8rem 0 1.15rem',
      marginBottom: '16px',
      $nest: {
        '.wrench-search': {
          height: '40px',
          backgroundColor: '#fff',
          $nest: {
            '&:hover fieldset': {
              borderColor: '#29ffee',
            },
          }
        },
        '.s5-MuiOutlinedInput-root.Mui-focused .s5-MuiOutlinedInput-notchedOutline': {
          color: '#495057',
          borderColor: '#29ffee',
          outline: 0,
          boxShadow: '0 0 0 0.2rem rgba(0, 168, 155, 0.25)',
        },
      },
    },
    '.columns-grid': {
      overflowY: 'auto',
      height: 'calc(100% - 40px - 40px - 50px)',// minus 50px here for button container

    },
    '.checkbox-container': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '.child-metric-container': {
      display: 'grid',
      gridTemplateColumns: 'auto 45px',
      width: '100%',
    },
    '.columns-checkbox': {
      width: '15%',
      textAlign: 'center',
      paddingTop: 1,
      marginLeft: 'auto',
    },
    '.item-text.metric-style': {
      paddingTop: 0,
    },
    '.item-text': {
      paddingLeft: 10,
      paddingTop: 13,
      width: '60%',
      textAlign: 'center',
      marginRight: 50,
    },
    '.item-name': {
      marginRight: 30,
      paddingTop: 10,
      width: '66%',
    },
  },
});

export const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  userSelect: 'none',
  cursor: isDragging ? 'grabbing' : 'grab',
  background: isDragging
    ? 'rgba(0,0,0,0.1)'
    : 'rgba(0,0,0,0.05)',
  marginBottom: 10,
  marginLeft: 20,
  marginRight: 20,
  ...draggableStyle,
});

export const getListStyle = (isDraggingOver: boolean, length: number) => ({
  // background: isDraggingOver ? 'lightblue' : 'inherit',
  width: '100%',
  // add 9px here because of marginBotton that extend the item outside of dragable container
  height: 59 * length,
});

export const configuratorAccordionOverrides = createStyles({
  root: {
    width: '100%',
    boxShadow: 'none',
  },
});

export const configuratorAccordionSummaryOverrides = createStyles({
  root: {
    flexDirection: 'row-reverse',
    background: 'inherit',
    height: 50,
    padding: '0',
    '&$expanded': {
      minHeight: 50,
    },
  },
  content: {
    display: 'grid',
    gridTemplateColumns: 'auto 100px',
    width: '100%',
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
});

export const configuratorAccordionDetailsOverrides = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 0 0 3rem',
    background: 'rgba(0, 0, 0, 0.05)',
  },
});

export const configuratorAccordionTypographyOverrides = createStyles({
  root: {
    marginLeft: ({ hasIcon }: StyledTypographyProps) => (hasIcon ? 0 : '1rem'),
    maxWidth: '80%',
    alignSelf: 'center',
  },
});

export const resetButtonStyles = style({
  width: 80,
  height: 35,
  borderStyle: 'none',
  cursor: 'pointer',
  boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
  borderRadius: 2,
  letterSpacing: 0.5,
  fontFamily: "Open Sans",
})

export default viewConfiguratorStyles;
